export * from './service';
export * from './resolves';



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/index.ts